// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"fd865834","703":"766a8e17","787":"d192da45"}[chunkId] + ".chunk.js";
};